import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const Glance = styled.div`
    min-height: 300px;
`;

export const FormLabel = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: ${token('color.text.accent.gray')};
    margin-bottom: ${token('space.050')};
`;

export const FormHelpText = styled.div`
    font-size: 11px;
    font-weight: 400;
    color: ${token('color.text.accent.gray')};
`;

export const ErrorMessage = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: ${token('color.text.accent.red')};
`;
